if (!customElements.get('localization-form')) {
   customElements.define('localization-form', class GeolocatorLocalizationForm extends HTMLElement {
      constructor() {
         super();
         this.elements = {
            button: this.querySelectorAll('.geolocator-select-country'),
            panel: this.querySelector('.disclosure__list-wrapper'),
            geolocatorForm: this.querySelector('.localization-form')
         };

         // Add event listeners for country select buttons
         this.elements.button?.forEach(btn => {
            btn.addEventListener('click', this.openSelector.bind(this));
         });

         // Add event listeners for language radio buttons
         this.querySelectorAll('input[type="radio"][name="locale_code"]').forEach(radio => {
            radio.addEventListener('change', this.onLanguageRadioChange.bind(this));
         });

         this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

         // Close country list
         document.querySelector('.geolocator-country-list__close')?.addEventListener('click', () => {
            this.elements.geolocatorForm?.classList.remove('active');
         });

         // Open modal from footer
         document.querySelector('.footer-geolocation-selector')?.addEventListener('click', () => {
            const modal = document.getElementById('GeolocatorModal');
            modal?.setAttribute('open', '');
         });

         // Set cookie on submit
         this.elements.geolocatorForm?.addEventListener('submit', () => {
            document.cookie = "country_selected=country_selected; path=/; max-age=31536000";
         });
      }

      hidePanel() {
         this.elements.button?.forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
         });
         this.elements.panel?.setAttribute('hidden', true);
      }

      onItemClick(event) {
         event.preventDefault();
         const form = this.querySelector('form');
         const value = event.currentTarget.dataset.value;

         if (event.currentTarget.hasAttribute('hreflang')) {
            // Language
            const input = this.querySelector('input[name="locale_code"]');
            if (input) input.value = value;
         } else {
            // Country
            const input = this.querySelector('input[name="country_code"]');
            if (input) input.value = value;

            // Submit via AJAX and refresh modal content only for Hong Kong
            if (form && value === 'hk') {
               form.classList.add('loading');
               const formData = new FormData(form);
               (async () => {
                  try {
                     const response = await fetch('/localization', {
                        method: 'POST',
                        body: formData,
                        headers: {
                           'Accept': 'text/html',
                        },
                     });
                     const html = await response.text();
                     form.classList.remove('loading');
                     const parser = new DOMParser();
                     const doc = parser.parseFromString(html, 'text/html');
                     const newModal = doc.getElementById('GeolocatorModal');
                     const modal = document.getElementById('GeolocatorModal');
                     if (modal && newModal) {
                        modal.innerHTML = newModal.innerHTML;
                        modal.classList.add('country-selected');
                        document.querySelector('.geolocator__confirm').disabled = false;
                     }
                  } catch (error) {
                     form.classList.remove('loading');
                  }
               })();
            } else {
               let selectedCountry = event.currentTarget.innerHTML;
               const countryInner = document.querySelector('.geolocator-select-country__inner');
               const languageList = document.querySelector('.geolocator-languages');

               this.elements.geolocatorForm?.classList.remove('active');
               document.getElementById('GeolocatorModal').classList.add('country-selected');
               document.querySelector('.geolocator__confirm').disabled = false;
               if (countryInner) countryInner.innerHTML = selectedCountry;
               if (languageList) languageList.style.display = 'none';

               // if selected country is KR instead of submitting the form confirm button should redirect to a fixed url
               if (value === 'kr') {
                  const confirmButton = document.querySelector('.geolocator__confirm');
                  if (confirmButton) {
                     confirmButton.removeEventListener('click', this.elements.geolocatorForm?.onsubmit);
                     confirmButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        window.location.href = 'http://www.grownalchemist.co.kr';
                     });
                  }
               }
            }
         }
      }

      onLanguageRadioChange(event) {
         const selected = event.target;
         const hiddenInput = this.querySelector('input[type="hidden"][name="locale_code"]');
         if (selected && hiddenInput) {
            hiddenInput.value = selected.value;
         }
      }

      openSelector() {
         this.elements.geolocatorForm?.classList.toggle('active');
         this.elements.panel?.toggleAttribute('hidden');
         this.elements.button?.forEach(btn => {
            btn.setAttribute('aria-expanded', (btn.getAttribute('aria-expanded') === 'false').toString());
         });
      }
   });
}
